module.exports = __webpack_public_path__ + "static/media/pg_sample_right_beaker_full.1e43df0b.svg";